/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function SEO({ description, meta, title, bodyClassName }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            keywords
            url
            fbAppId
            twSite
          }
        }
      }
    `
  )

  const metaTitle = title || site.siteMetadata.title
  const metaDescription = description || site.siteMetadata.description
  const metaKeywords = site.siteMetadata.keywords
  const metaUrl = site.siteMetadata.url
  const metaFbAppId = site.siteMetadata.fbAppId
  const metaTwSite = site.siteMetadata.twSite

  return (
    <Helmet
      title={metaTitle}
      bodyAttributes={{
        class: bodyClassName,
      }}
      link={[
        { rel: "icon", href: "/favicon.ico", type: "image/x-icon" },
        {
          rel: "apple-touch-icon",
          sizes: "180x180",
          href: "/metadata/apple-touch-icon.png",
        },
      ]}
      script={[
        { src: "https://www.gstatic.com/firebasejs/7.13.1/firebase-app.js", type: "text/javascript" },
        { src: "https://www.gstatic.com/firebasejs/7.13.1/firebase-analytics.js", type: "text/javascript" },
        { sec: "https://js.hs-scripts.com/9495327.js", type: "text/javascript" },
      ]}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          name: `keywords`,
          content: metaKeywords,
        },
        {
          property: `og:title`,
          content: metaTitle,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:url`,
          content: metaUrl,
        },
        {
          property: `og:image`,
          content: "/metadata/ogp.png",
        },
        {
          property: `fb:app_id`,
          content: metaFbAppId,
        },
        {
          name: `twitter:card`,
          content: `summary_large_image`,
        },
        {
          name: `twitter:site`,
          content: metaTwSite,
        },
        {
          name: `twitter:title`,
          content: metaTitle,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          property: `twitter:image`,
          content: "/metadata/ogp.png",
        },
      ].concat(meta)}
    >
      <script type="text/javascript" id="hs-script-loader" async defer src="//js.hs-scripts.com/9495327.js"></script>
    </Helmet>
  )
}

SEO.defaultProps = {
  meta: [],
  description: ``,
  title: ``,
  bodyClassName: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
  bodyClassName: PropTypes.string,
}

export default SEO
